<template>
  <el-dialog
    title="个人信息"
    :visible.sync="show"
    width="600px"
    append-to-body
    :before-close="close"
  >
    <div class="personal-info">
      <p><strong>用户账号：</strong>{{ userInfo.username }}</p>
      <p><strong>真实姓名：</strong>{{ userInfo.realName }}</p>
      <p><strong>部门：</strong>{{ userInfo.deptName }}</p>
      <p><strong>角色：</strong>
        <ElTag class="mr-1" v-for="item in userInfo.roleNameList" :key="item">{{ item }}</ElTag>
      </p>
      <!-- 如果有更多字段，如头像或邮箱，可以在这里添加 -->
      <p v-if="userInfo.email"><strong>邮箱：</strong>{{ userInfo.email }}</p>
      <p v-if="userInfo.phone"><strong>电话：</strong>{{ userInfo.phone }}</p>
      <p v-if="userInfo.roomName"><strong>宿舍：</strong>{{userInfo.dormitoryName }}第{{userInfo.floorNum }}层{{userInfo.roomName}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import dialog from '@/vue/mixins/dialog'

export default {
  name: 'DialogUserInfo',
  mixins: [dialog],
  props: {},
  data() {
    return {
      departmentList: []
    }
  },
  computed: {
    ...mapState('login', {
      userInfo: (state) => state.userInfo
    })
  },
  created() {
    this.getDepartmentList()
  },
  methods: {
    // 获取部门
    async getDepartmentList() {
      try {
        const res = await this.$http.getDepartmentListQuery({})
        if (this.userInfo.deptId) {
          this.userInfo.deptName = res.data.find(item => item.id === this.userInfo.deptId).deptName
        }
      } catch (e) {
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-info {
  p {
    margin-bottom: 10px;
    font-size: 14px;
  }
}
</style>
